import script from "./WageExcelMigrationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WageExcelMigrationModal.vue?vue&type=script&setup=true&lang=ts"

import "./WageExcelMigrationModal.vue?vue&type=style&index=0&id=3b89535a&lang=scss"

const __exports__ = script;

export default __exports__